import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetSeatmapsRequest,
  failGetSeatmaps,
  setGetSeatmaps,
  setGetSeatmapsFromApi,
  updateGetSeatmaps,
  updateGetSeatmapsFromApi,
} from './get-seatmaps.actions';

/**
 * Service to handle async GetSeatmaps actions
 */
@Injectable()
export class GetSeatmapsEffect {
  /**
   * Set the state with the reply content, dispatch failGetSeatmaps if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetSeatmapsFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetSeatmaps({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetSeatmaps({ error, requestId: action.requestId })),
        cancelGetSeatmapsRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetSeatmaps if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetSeatmapsFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetSeatmaps({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetSeatmaps({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
